import React, { useState, useEffect } from "react";
import apiClient from "../api.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaLocationDot, FaIndianRupeeSign } from "react-icons/fa6";
import { FaBuilding } from "react-icons/fa";
import Popup from "../components/Popup.jsx";
import Animationthankyou from "../assets/img/Animationthankyou.gif";
import Canonical from "../components/Canonical.js";

const SeoPropertiesByRegionGoregaon = () => {
  //   const region = window.location.pathname.split("/").pop();
  const path = window.location.pathname;
  const parts = path.split("-");

  const afterSecondDash = parts.slice(2).join("-"); // "andheri-west"
  const afterSecondDashCapital =
    afterSecondDash.charAt(0).toUpperCase() + afterSecondDash.slice(1);

  const params = useParams();
  const [property, setProperty] = useState({});
  const [propertySingle, setPropertySingle] = useState({});
  const [loading, setLoading] = useState(false);
  const [subject, setSubject] = useState("");
  // const urlVariableChange = params.subregionname.replace(/-/g, " ");

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(
          `listing/propertysubregion/${afterSecondDashCapital}`
        );
        if (res.status === 200) {
          setPropertySingle(res.data[0]);
          setProperty(res.data);
          setSubject(res.data[0].subregion);
          //   setError(true);
          // setShowMore(true);
          setLoading(false);
        }
      } catch (error) {
        // setError(true);
        setLoading(false);
      }
    };

    fetchProperties();
  }, [afterSecondDashCapital]);

  const onShowMoreClick = async () => {
    const numberOfProperty = property.length; // Already loaded properties
    const limit = 10;

    try {
      setLoading(true);
      const res = await apiClient.get(
        `listing/propertysubregion/${params.subregionname}?skip=${numberOfProperty}&limit=${limit}`
      );

      if (res.data.length <= 10) {
        // console.log(res.data);

        // setShowMore(false);
        setLoading(false);
        // setError(false);

        setProperty([...property, ...res.data]);
      }
      // setShowMore(true);
    } catch (error) {
      //   setError(true);
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   let isFetching = false;

  //   const handleScroll = () => {
  //     const scrollTop =
  //       document.documentElement.scrollTop || document.body.scrollTop;
  //     const windowHeight = window.innerHeight;
  //     const docHeight = document.documentElement.scrollHeight;

  //     const scrolledPercent = (scrollTop + windowHeight) / docHeight;

  //     // Only trigger if not already loading and past 50%
  //     if (scrolledPercent >= 0.5 && !isFetching && !loading) {
  //       isFetching = true;
  //       onShowMoreClick().finally(() => {
  //         isFetching = false;
  //       });
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [loading, property]);

  // handle popup button
  const [popupData, setPopupData] = useState("");

  const handleButtonClick = (dataName) => {
    // Set the value you want to send to the Popup
    // console.log(dataName);
    setPopupData(dataName);
  };

  // save lead form data

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const res = await apiClient.post("emailsend/send-email", {
        email,
        subject,
        mobile,
        name,
      });

      if (res) {
        // Hide the main form popup
        const mainPopup = document.getElementById("staticBackdrop");
        if (mainPopup) {
          const bootstrapModal = window.bootstrap.Modal.getInstance(mainPopup);
          if (bootstrapModal) bootstrapModal.hide();
        }
        navigate("/thank-you"); // Redirect after successful response
        // window.location.reload(); // Forces a full page reload
        setShowSuccessPopup(true); // Show success popup
        setEmail("");
        setName("");
        setMobile("");
        setSubject("");
      }
    } catch (error) {
      // console.log(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    navigate("/thank-you"); // Redirect or perform other actions if necessary
    window.location.reload(); // Forces a full page reload
  };

  const canonicalUrl = `https://homesdekho.com${path}`;
  const metaTitle = `Properties for Sale in ${propertySingle.subregion}, Mumbai | Homes Dekho`;
  const hrfLangTag = `https://homesdekho.com${path}`;
  const description = `Discover 1, 2, 3 BHK residential properties in ${propertySingle.subregion}, Mumbai by top builders. Get brochures, floor plans & expert help with Homes Dekho. Book your flat now.`;

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={metaTitle}
        description={description}
        hrfLang={hrfLangTag}
      />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12">
            {loading && (
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* property Detail  */}
      <main className="main-section">
        <section className="main-side">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="region-name-div">
                  <ul className="region-name-ul">
                    <li className="region-name-li">
                      <Link>Homes In Mumbai</Link>
                      <IoIosArrowDown />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12">
                <div className="region-name-div">
                  <ul className="property-region-name-ul">
                    <li className="property-region-name-li">
                      <Link>Homes In Mumbai</Link>
                    </li>
                    <li className="property-region-name-li">
                      <Link>
                        {propertySingle.subregion === "Dombivali"
                          ? "Dombivli"
                          : propertySingle.subregion}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12">
                <div className="filter-main-div">
                  <ul className="filter-main-ul">
                    <li className="filter-main-li">
                      Possession
                      <IoIosArrowDown />
                    </li>
                    <li className="filter-main-li">
                      Bedrooms
                      <IoIosArrowDown />
                    </li>
                    <li className="filter-main-li">
                      Price
                      <IoIosArrowDown />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12">
                <div className="property-region-name-li-region">
                  <h1 className="property-name-region">Property In Goregaon</h1>
                </div>
              </div>

              <div className="col-md-12">
                {Array.isArray(property) &&
                  property.map((propertyDetail, index) => (
                    <div
                      key={propertyDetail._id}
                      className="devloper-name-property-div"
                    >
                      <div className="devloper-name-property-inner-div">
                        <div className="devloper-name-property-img-div">
                          <Link to={`/property-detail/${propertyDetail.slug}`}>
                            <img
                              className="devloper-name-property-img "
                              src={propertyDetail.imageUrls}
                              alt={propertyDetail.name}
                            />
                          </Link>
                        </div>
                        <div className="property-detail-right-div">
                          <Link
                            to={`/property-detail/${propertyDetail.slug}`}
                            className="property-devloper-name-txt"
                          >
                            {propertyDetail.name}
                          </Link>
                          <div className="property-devloper-name-detail-div">
                            <FaLocationDot />
                            <p className="property-by-subregion-address-txt">
                              {propertyDetail.address}
                            </p>
                          </div>
                          <div className="property-devloper-name-detail-div">
                            <FaBuilding />
                            <p className="property-by-subregion-address-txt">
                              {propertyDetail.BHK &&
                              Array.isArray(propertyDetail.BHK) ? (
                                propertyDetail.BHK.map((bhk, idx) => (
                                  <span key={idx}>
                                    {bhk}
                                    {idx < propertyDetail.BHK.length - 1 &&
                                      ", "}
                                  </span>
                                ))
                              ) : (
                                <span>Loading data...</span>
                              )}{" "}
                              BHK
                            </p>
                          </div>
                          <div className="best-deal-price-range-div">
                            <FaIndianRupeeSign />
                            <p className="property-by-subregion-address-txt">
                              {propertyDetail.price}
                            </p>
                          </div>
                          <div className="property-devloper-btn-div">
                            <Link
                              to={`/property-detail/${propertyDetail.slug}`}
                              className="view-detail-btn-property"
                            >
                              View Details
                            </Link>
                            <button
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              onClick={() =>
                                handleButtonClick(propertySingle.name)
                              }
                              className="get-call-btn-property-by-region"
                            >
                              Enquire Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                {/* {showMore === false ? (
                  ""
                ) : (
                  <button className="btn btn-success" onClick={onShowMoreClick}>
                    Show More
                  </button>
                )} */}

                <div className="col-md-12">
                  {/* View More Properties Button */}
                  {property.length % 10 === 0 && property.length > 0 && (
                    <div className="text-center my-4">
                      <button
                        className="get-call-btn-property-by-region"
                        onClick={onShowMoreClick}
                        disabled={loading}
                      >
                        {loading ? "Loading..." : "View More Properties"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 mobile-property">
                <div className="property-details-div">
                  <p className="best-deal-txt">
                    Best Deal in {propertySingle.subregion}
                  </p>
                  <div className="best-property-deal-div">
                    <Link to={`/property-detail/${propertySingle.slug}`}>
                      <img
                        src={propertySingle.imageUrls}
                        className="best-deal-property-img img-fluid"
                        alt=""
                      />
                    </Link>
                    <Link
                      to={`/property-detail/${propertySingle.slug}`}
                      className="best-deal-property-name"
                    >
                      {propertySingle.name}
                    </Link>
                    <div className="best-deal-property-address-div">
                      <FaLocationDot className="location-icon" />
                      <p className="best-deal-property-address-txt">
                        {propertySingle.address}
                      </p>
                    </div>
                    <div className="best-ceal-property-detail-price">
                      <div className="best-deal-bhk-range">
                        <FaBuilding />
                        <p className="best-deal-property-address-txt">
                          {propertySingle.BHK &&
                          Array.isArray(propertySingle.BHK) ? (
                            propertySingle.BHK.map((bhk, index) => (
                              <span key={index}>
                                {bhk}
                                {index < propertySingle.BHK.length - 1 && ", "}
                              </span>
                            ))
                          ) : (
                            <span>Loading data...</span>
                          )}{" "}
                          BHK
                        </p>
                      </div>
                      <div className="best-deal-price-range-div">
                        <FaIndianRupeeSign />
                        <p className="best-deal-property-address-txt">
                          {propertySingle.price}
                        </p>
                      </div>
                    </div>
                    <div className="best-deal-btn-div">
                      <Link
                        to={`/property-detail/${propertySingle.slug}`}
                        className="view-detail-btn"
                      >
                        View Details
                      </Link>

                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        onClick={() => handleButtonClick(propertySingle.name)}
                        className="get-call-btn"
                      >
                        Enquire Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="side-bar">
          <div className="container">
            <div className="row">
              {/* property detail  */}
              <div className="col-md-12">
                <div className="property-details-div">
                  <p className="best-deal-txt">
                    Best Deal in {propertySingle.subregion}
                  </p>
                  <div className="best-property-deal-div">
                    <Link to={`/property-detail/${propertySingle.slug}`}>
                      <img
                        src={propertySingle.imageUrls}
                        className="best-deal-property-img img-fluid"
                        alt=""
                      />
                    </Link>
                    <Link
                      to={`/property-detail/${propertySingle.slug}`}
                      className="best-deal-property-name"
                    >
                      {propertySingle.name}
                    </Link>
                    <div className="best-deal-property-address-div">
                      <FaLocationDot className="location-icon" />
                      <p className="best-deal-property-address-txt">
                        {propertySingle.address}
                      </p>
                    </div>
                    <div className="best-ceal-property-detail-price">
                      <div className="best-deal-bhk-range">
                        <FaBuilding />
                        <p className="best-deal-property-address-txt">
                          {propertySingle.BHK &&
                          Array.isArray(propertySingle.BHK) ? (
                            propertySingle.BHK.map((bhk, index) => (
                              <span key={index}>
                                {bhk}
                                {index < propertySingle.BHK.length - 1 && ", "}
                              </span>
                            ))
                          ) : (
                            <span>Loading data...</span>
                          )}{" "}
                          BHK
                        </p>
                      </div>
                      <div className="best-deal-price-range-div">
                        <FaIndianRupeeSign />
                        <p className="best-deal-property-address-txt">
                          {propertySingle.price}
                        </p>
                      </div>
                    </div>
                    <div className="best-deal-btn-div">
                      <Link
                        to={`/property-detail/${propertySingle.slug}`}
                        className="view-detail-btn"
                      >
                        View Details
                      </Link>

                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        onClick={() => handleButtonClick(propertySingle.name)}
                        className="get-call-btn"
                      >
                        Enquire Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* property detail  */}
              <div className="col-md-12">
                <div className="main-form-div">
                  <div className="need-help-txt-div">
                    <h4 className="need-help-txt">Need Help?</h4>
                  </div>
                  <div className="lead-form-div">
                    <form onSubmit={handleSubmit} className="lead-form">
                      <input
                        placeholder="Name*"
                        className="lead-form-input"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />

                      <input
                        placeholder="Mobile*"
                        className="lead-form-input"
                        type="tel"
                        pattern="[789][0-9]{9}"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        required
                      />
                      <input
                        placeholder="Email*"
                        className="lead-form-input"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <div className="download-brochure-btn-div">
                        {isSubmitting ? (
                          <div class="spinner-border text-danger" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <button
                            className={`form-enquire-btn ${
                              isSubmitting ? "disabled" : ""
                            }`}
                            type="submit"
                            disabled={isSubmitting}
                          >
                            Enquire Now
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Success Popup */}
        {showSuccessPopup && (
          <div
            className="modal-overlay"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-content success-popup">
              <button
                className="close-btn"
                onClick={handleSuccessPopupClose}
                aria-label="Close"
              >
                &times;
              </button>
              <div className="w-100">
                {/* <FaCheckCircle className="success-icon text-center" /> */}
                <img src={Animationthankyou} alt="" />
              </div>
              <h2>Thank you!</h2>
              <p>We've received your submission, and we'll be in touch soon!</p>
            </div>
          </div>
        )}
        <Popup data={popupData} />
      </main>
    </>
  );
};

export default SeoPropertiesByRegionGoregaon;
